import { render } from "./templateMomo.vue?vue&type=template&id=55e16e96&scoped=true"
import script from "./templateMomo.vue?vue&type=script&lang=js"
export * from "./templateMomo.vue?vue&type=script&lang=js"

import "./templateMomo.vue?vue&type=style&index=0&id=55e16e96&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e16e96"]])

export default __exports__